import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';

import { CrystalDetails } from './CrystalDetails';
import styles from './Crystals.module.scss';
import { CrystalGrid } from './CrystalGrid';
import { CrystalsData } from './types';

interface CrystalsProps {
  data: CrystalsData;
}

export function Crystals({ data }: CrystalsProps) {
  const isDetail = data?.type === 'detail';
  const contentKey = isDetail ? 'detail' : `grid-${data.items.map(i => i.name).join(',')}`;

  return (
    <div className={styles.view}>
      <div className={styles.title}>Камни</div>
      {/* @ts-expect-error framer-motion types incompatible with @types/react 18 */}
      <AnimatePresence mode="wait">
        <motion.div
          key={contentKey}
          className={styles.content}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 0.45, ease: [0.16, 1, 0.3, 1] } }}
          exit={{
            opacity: 0,
            filter: 'blur(8px)',
            transition: {
              filter: { duration: 0.25, ease: 'easeIn' },
              opacity: { duration: 0.3, ease: 'easeIn' },
            },
          }}
        >
          {!isDetail ? <CrystalGrid items={data.items} /> : <CrystalDetails data={data.item} />}
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
